import {useQuery, UseQueryResult} from "react-query";
import {API, ApiResponseBase, CustomAxiosError} from "../../../logics/api-config";
import {IRestaurateur} from "../../../utils/interfaces/IRestaurateur";


export interface ApiResponse extends ApiResponseBase {
    data: IRestaurateur[];
}


async function doGet(): Promise<IRestaurateur[]> {
    try {
        const response = await API.get(`/accounting/restaurateurs`);
        const responseData: ApiResponse = response?.data;
        return responseData.data;
    } catch (error) {
        throw error;
    }
}

const useApiGetRestaurateurs = (): UseQueryResult<IRestaurateur[], CustomAxiosError> => {
    return useQuery<IRestaurateur[], CustomAxiosError>("getRestaurateurs", doGet);
};


export default useApiGetRestaurateurs